import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";

export const getApplications = () => http({
    url: ENDPOINTS.application.browse,
    method: 'get',

}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject( err);
});


export const getApplicationWithRoute = () => http({
    url: ENDPOINTS.application.ApplicationWithRootMenu,
    method: 'get',

}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject( err);
});

export const setDefaultProcces = (Id , PRJ_UID) => http({
    url: ENDPOINTS.bpmnApi.bpmnProcessApplication.setDefault,
    method: 'post',
    params:{
        applicationId:Id,
        PRJ_UID:PRJ_UID
    }

}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject( err);
});


